import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CompanyForm from "~/forms/CompanyForm";
import { Icon, InputCheckbox, InputText, Label, Text } from "~/components-shared";
import api from "~/lib/api";
import { AuthoritiesEnum } from "~/types/enums";
import styled, { useTheme } from "styled-components";
import { useSelector } from "react-redux";
import companySelectors from "~/store/company/selectors";
import InputSelectControl from "~/components/InputSelectControl";
import lists from "~/lib/lists";
import InputToggleControl from "~/components/InputToggleControl";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Authorities = styled.div`
  flex-grow: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  min-height: 400px;
`;
const ManageCompanyForm = _ref => {
  let {
    control,
    watch,
    setValue,
    setError
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const company = useSelector(companySelectors.getCompany);
  const [authorities, setAuthorities] = useState([]);
  let tempAuthorities = authorities;
  const [search, setSearch] = useState("");
  useEffect(() => {
    api.fetchManageAuthorities().then(response => {
      setAuthorities(response);
    });
  }, []);
  if (search) {
    tempAuthorities = authorities.filter(authority => authority.includes(search));
  }
  const groupedAuthorities = tempAuthorities ? tempAuthorities.reduce((groups, authority) => {
    const prevGroups = groups;
    const [mainPart] = authority.split(".");
    const [levels] = mainPart.split(":");
    const [primary] = levels.split("/");
    if (!prevGroups[primary]) {
      prevGroups[primary] = [];
    }
    groups[primary].push(authority);
    return prevGroups;
  }, {}) : {};
  const handleChange = authority => {
    const selected = watch("authorities");
    if (selected.includes(authority)) {
      setValue("authorities", selected.filter(item => item !== authority));
    } else {
      setValue("authorities", [...selected, authority]);
    }
  };
  const handleChangeGroup = key => {
    const selected = watch("authorities");
    const filtered = selected.filter(item => !item.startsWith(key));
    const selectedAll = watch("authorities").sort().join().includes(groupedAuthorities[key].join());
    if (selectedAll) {
      setValue("authorities", filtered);
    } else {
      setValue("authorities", [...filtered, ...authorities.filter(item => item.startsWith(key))]);
    }
  };
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(CompanyForm, {
    control: control,
    watch: watch,
    setValue: setValue,
    setError: setError,
    company: company
  }), /*#__PURE__*/React.createElement(InputSelectControl, {
    s: {
      mt: 3,
      mb: 3
    },
    label: t("ManageCompanyForm.recommendedIntegrations"),
    name: "settings.recommendedIntegrations",
    options: lists.integrations.types.names,
    control: control,
    fullSelections: true,
    multiple: true
  }), /*#__PURE__*/React.createElement(InputToggleControl, {
    name: "settings.sendSlackStatusReport",
    label: t("ManageCompanyForm.sendSlackStatusReport"),
    control: control,
    s: {
      mb: 3
    }
  }), /*#__PURE__*/React.createElement(Label, {
    s: {
      mb: 2
    },
    required: true
  }, t("MemberForm.authorities")), /*#__PURE__*/React.createElement(InputText, {
    value: search,
    placeholder: t("ManageCompanyForm.searchAuthorities"),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      color: colors.text.secondary,
      src: "search",
      s: {
        mr: 2
      }
    }),
    onChange: value => setSearch(value),
    s: {
      mb: 3
    },
    clearButton: true
  }), /*#__PURE__*/React.createElement(Authorities, null, Object.keys(groupedAuthorities).map(key => /*#__PURE__*/React.createElement(React.Fragment, {
    key: key
  }, /*#__PURE__*/React.createElement(InputCheckbox, {
    value: watch("authorities").sort().join().includes(groupedAuthorities[key].join()),
    onChange: () => handleChangeGroup(key),
    label: /*#__PURE__*/React.createElement(Text, {
      element: "h3"
    }, key)
  }), groupedAuthorities[key].map(authority => /*#__PURE__*/React.createElement(InputCheckbox, {
    key: authority,
    value: watch("authorities").includes(authority),
    onChange: () => handleChange(authority),
    label: authority,
    color: [AuthoritiesEnum.MANAGE_COMPANIES_READ, AuthoritiesEnum.MANAGE_COMPANIES_WRITE, AuthoritiesEnum.EXPERIMENTAL, AuthoritiesEnum.AI_PROMPTS_READ, AuthoritiesEnum.AI_PROMPTS_WRITE, AuthoritiesEnum.COSTS_READ, AuthoritiesEnum.ORG_CHART_READ, AuthoritiesEnum.ORG_CHART_WRITE, AuthoritiesEnum.FOOTPRINTS_READ, AuthoritiesEnum.FOOTPRINTS_WRITE, AuthoritiesEnum.WORKING_STYLES_READ, AuthoritiesEnum.WORKING_STYLES_WRITE, AuthoritiesEnum.OVERVIEW_READ, AuthoritiesEnum.EVENTS_READ, AuthoritiesEnum.EVENTS_WRITE, AuthoritiesEnum.ONBOARDING_TOPICS_WRITE, AuthoritiesEnum.ONBOARDING_DESCRIBE_COMMUNITY_WRITE, AuthoritiesEnum.ONBOARDING_ADD_COMMUNITIES_WRITE, AuthoritiesEnum.ACTIVITY_READ, AuthoritiesEnum.COMMUNITIES_READ, AuthoritiesEnum.COMMUNITIES_WRITE, AuthoritiesEnum.REQUESTS_READ, AuthoritiesEnum.REQUESTS_WRITE, AuthoritiesEnum.REQUEST_COMMENTS_READ, AuthoritiesEnum.REQUEST_COMMENTS_WRITE, AuthoritiesEnum.EVENT_SURVEYS_READ, AuthoritiesEnum.EVENT_SURVEYS_WRITE].includes(authority) ? colors.danger.main : colors.primary.main,
    s: {
      ml: 5
    }
  }))))));
};
export default ManageCompanyForm;